import React from 'react';
import { Button, Modal } from 'rsuite';

type UnsavedChangesModalProps = {
  open: boolean;
  onStay: () => void;
  onDiscard: () => void;
  message?: string;
};

export default function UnsavedChangesModal({
  open,
  onStay,
  onDiscard,
  message = 'You have unsaved changes. Discard them and leave this page?',
}: UnsavedChangesModalProps) {
  return (
    <Modal
      backdrop="static"
      role="alertdialog"
      open={open}
      onClose={onStay}
      size="xs"
    >
      <Modal.Header>
        <Modal.Title>Unsaved changes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onStay} appearance="primary">
          Stay
        </Button>
        <Button onClick={onDiscard} appearance="subtle">
          Discard changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
